module.exports = __webpack_public_path__ + "img/eye2.163df25c.svg";